/* Normalize only purchase labels, including labels re-rendered by apps.
   Preserve icons, click handlers, variant selection and unavailable states. */
(()=>{
  const selector='button,a,input[type="submit"]';
  const oldLabel=/^(ajouter au panier|acheter maintenant|achetez-le maintenant|buy it now|add to cart|je commande|je valide ma commande)$/i;
  function normalize(root){
    const items=[];
    if(root.nodeType===1&&root.matches(selector))items.push(root);
    if(root.querySelectorAll)items.push(...root.querySelectorAll(selector));
    for(const el of items){
      if(el.disabled||el.getAttribute('aria-disabled')==='true'||el.getAttribute('data-button-status')==='sold-out')continue;
      if(el.tagName==='INPUT'){if(oldLabel.test(el.value.trim())&&el.value!=='Je Commande')el.value='Je Commande';continue;}
      const label=el.matches('.details-info .js_add_to_cart_button')&&el.closest('form')?.querySelector('[data-buyitnow-button]')?'Ajouter au panier':'Je Commande';
      const walker=document.createTreeWalker(el,NodeFilter.SHOW_TEXT);
      let node;
      while((node=walker.nextNode())){
        const text=node.nodeValue.trim();
        if(oldLabel.test(text)&&text!==label)node.nodeValue=node.nodeValue.replace(text,label);
      }
      if(oldLabel.test(el.getAttribute('aria-label')||''))el.setAttribute('aria-label',label);
    }
  }
  const invitationObserver='IntersectionObserver' in window?new IntersectionObserver(entries=>{
    entries.forEach(({target,isIntersecting})=>{if(isIntersecting){target.classList.add('dk-order-invite');invitationObserver.unobserve(target);}});
  },{threshold:0.7}):null;
  function polishProduct(){
    document.querySelectorAll('.dk-inventory').forEach(el=>{
      const data=el.querySelector('[data-dk-inventory-map]');
      if(!data)return;
      let states;try{states=JSON.parse(data.textContent);}catch{return;}
      const form=el.closest('form');
      const id=form?.querySelector('[name="id"]')?.value||el.dataset.dkInitialVariant;
      const state=states[id]||'confirm';
      if(el.dataset.stockState!==state)el.dataset.stockState=state;
      const label=el.querySelector('[data-dk-stock-label]');
      const text={stock:'En stock',unavailable:'Indisponible',confirm:'Sur commande'}[state];
      if(label&&label.textContent!==text)label.textContent=text;
      const note=form?.querySelector('[data-dk-stock-note]');
      if(note&&note.hidden!==(state!=='confirm'))note.hidden=state!=='confirm';
    });
    document.querySelectorAll('.details-info .shopify-payment-button__button--unbranded').forEach(el=>{
      if(el.dataset.dkInvite)return;el.dataset.dkInvite='1';
      if(invitationObserver)invitationObserver.observe(el);
    });
    document.querySelectorAll('.details-info buy-now').forEach(el=>{
      if(el.parentElement.querySelector('.dk-order-guidance'))return;
      const note=document.createElement('p');note.className='dk-order-guidance';
      note.textContent='Renseignez vos coordonnées à l’étape suivante.';
      el.after(note);
    });
    document.querySelectorAll('.details-info .button_whatsapp').forEach(el=>{
      const name=el.querySelector('.online_user_name'), sub=el.querySelector('.online_user_title');
      if(name&&name.textContent!=="Besoin d’aide pour commander ?")name.textContent="Besoin d’aide pour commander ?";
      if(sub&&sub.textContent!=='WhatsApp')sub.textContent='WhatsApp';
      el.setAttribute('aria-label','Besoin d’aide pour commander ? Contactez-nous sur WhatsApp');
      if(!el.hasAttribute('href')){
        el.setAttribute('role','button');el.setAttribute('tabindex','0');
        if(!el.dataset.dkKeyboard){el.dataset.dkKeyboard='1';el.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();el.click();}});}
      }
    });
    document.querySelectorAll('.details-info .product-price').forEach(el=>{
      const walker=document.createTreeWalker(el,NodeFilter.SHOW_TEXT);let n;
      while((n=walker.nextNode())){const next=n.nodeValue.replace(/(\d),(?=\d{3}(?:\D|$))/g,'$1\u202f');if(next!==n.nodeValue)n.nodeValue=next;}
    });
  }
  function start(){
    document.addEventListener('change',()=>requestAnimationFrame(polishProduct));
    document.addEventListener('variant:change',polishProduct);
    normalize(document);
    polishProduct();
    new MutationObserver(records=>{
      const roots=new Set();
      for(const r of records){
        if(r.type==='characterData'){const b=r.target.parentElement?.closest(selector);if(b)roots.add(b);}
        else for(const n of r.addedNodes){if(n.nodeType===1)roots.add(n);else if(n.parentElement?.closest(selector))roots.add(n.parentElement.closest(selector));}
      }
      roots.forEach(normalize);
      polishProduct();
    }).observe(document.body,{subtree:true,childList:true,characterData:true});
  }
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',start,{once:true}):start();
})();
